import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from '@bufferapp/ui';
import FlashIcon from '@bufferapp/ui/Icon/Icons/Flash';
import { actions as composerPopoverActions } from '~/composer-popover';
import { useShowThreadsUpgrade } from '~/utils/canQueueMoreThreadsForAllTwitterProfiles';
import { SERVICE_YOUTUBE } from '~/constants';
import { ButtonStyled } from './styles';
import { SentPostActions } from './SentPostActions';

export const ShareAgainAction = ({ post, setOpenModal }) => {
  const dispatch = useDispatch();
  const { shouldShowThreadsMigrationModal } = useShowThreadsUpgrade(post);

  const isYoutubeWithServiceLink =
    post.channel.service === SERVICE_YOUTUBE && post.serviceLink;

  return (
    <>
      {(() => {
        if (shouldShowThreadsMigrationModal) {
          return (
            <Button
              data-testid="threads-free-paywall-button"
              type="primary"
              size="small"
              icon={<FlashIcon color="white" />}
              label="Upgrade to Schedule Thread"
              onClick={() =>
                setOpenModal({
                  open: true,
                  ctaString:
                    'calendarSent-upgradeButton-upgradeToScheduleThread-1',
                })
              }
            />
          );
        }

        if (isYoutubeWithServiceLink) {
          return <SentPostActions post={post} />;
        }

        return (
          <ButtonStyled
            type="secondary"
            size="small"
            label="Share Again"
            onClick={() =>
              dispatch(composerPopoverActions.handleShareAgainClick(post.id))
            }
          />
        );
      })()}
    </>
  );
};

ShareAgainAction.propTypes = {
  post: PropTypes.shape({
    id: PropTypes.string.isRequired,
    channel: PropTypes.shape({
      service: PropTypes.string.isRequired,
    }).isRequired,
    serviceLink: PropTypes.string,
  }).isRequired,
  setOpenModal: PropTypes.func,
};

ShareAgainAction.defaultProps = {
  setOpenModal: null,
};
